import propTypeOneOfFunction from './propTypeOneOfFunction';
import SolidButton from './SolidButton';
import OutlineButton from './OutlineButton';

export default propTypeOneOfFunction([
  SolidButton,
  OutlineButton
]);
